<div [ngClass]="{ 'toyota-banner' : isToyota , 'lexus-banner' : !isToyota,'toyota-banner-internal' : (appName === 'toyota' && isInternal) , 'lexus-banner-internal' :  (appName === 'lexus' && isInternal)}"
    *ngIf="showBanner(bannerId) && !this.isCloseClicked">
    <div class="row">
        <div class="col-10 banner-content" [ngClass]="{ 'toyota-banner-content' : isToyota , 'lexus-banner-content' : !isToyota}"
            [ngStyle]=" (this.windowWidth < 1440 && isSingleLine && !showShortDescription) ? { 'height' : 'auto', 'overflow': 'none'} : 
            ( (showShortDescription || isSingleLine) ? { 'height' : '1.8rem', 'overflow': 'hidden' } : 
            { 'height' : 'auto', 'overflow': 'none'} ) ">
            <span class="d-flex banner-content-block" [ngClass]="showShortDescription ? 'scrolling-banner' : ''" >
                <span>
                    <button *ngIf="this.showAlertIcon" disabled mat-icon-button style="height: auto; vertical-align: top; margin-top: -1px;">
                        <mat-icon class="alert-icon-banner">error_outline</mat-icon>
                    </button>
                </span>
                <span >
                    <span id="banner-text" [innerHTML]="banner.content" ></span>
                </span>
            </span>

        </div>
        <div class="banner-toggle-button col-2">
            <span style="float: right;display: flex" class="banner-button-block">
                <button *ngIf="!this.isSingleLine || this.windowWidth < 1440" mat-icon-button (click)="expandBanner()" style="height: auto;display: inline-block; vertical-align: top;"
                    #actionInfoTooltip="matTooltip" [matTooltip]="tip" matTooltipPosition="below" matTooltipShowDelay="100" matTooltipHideDelay="800"
                    [matTooltipClass]="{ 'tooltip-banner-toyota' : isToyota , 'tooltip-banner-lexus' : !isToyota }" (mouseenter)="hideTooltipIn(actionInfoTooltip, 800)">
                    <mat-icon class="arrow-up-icon">{{ arrowIcon }}</mat-icon>
                </button>

                <button mat-icon-button (click)="closeBanner()" style="height: auto; display: inline-block; vertical-align: top;" #actionCloseTooltip="matTooltip"
                    matTooltip="close" matTooltipPosition="below" matTooltipShowDelay="100" matTooltipHideDelay="800" [matTooltipClass]="{ 'tooltip-banner-toyota' : isToyota , 'tooltip-banner-lexus' : !isToyota }"
                    (mouseenter)="hideTooltipIn(actionCloseTooltip, 800)">
                    <mat-icon class="close-icon">close</mat-icon>
                </button>
            </span>
        </div>
    </div>
</div>